module.exports = __webpack_public_path__ + "p-footer.39a451ec.jpg";